function wxReady (callback) {
    if (window.__wxjs_environment === 'miniprogram') { // 微信小程序内
        if (callback && typeof callback === 'function') {
            callback();
        }
    }
}

function wxMiniprogram (callback) {
    if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
        document.addEventListener('WeixinJSBridgeReady', () => {
            wxReady(callback);
        }, false);
    } else {
        wxReady(callback);
    }
}

export default wxMiniprogram;
